import {createFileRoute} from '@tanstack/react-router'

import CompetitorsScreen from '@protected/competitors'

export const Route = createFileRoute('/_protected/competitors')({component: CompetitorsScreen})
